module.exports = __webpack_public_path__ + "img/Photo_6__Third_Canal976_262_3.bd3236b9.jpg";